/*
  RevoRope — las cinco métricas de la pantalla (ficha Tech) como tablist.

  Fichero propio a propósito: no comparte nada con rr-carousel.js (coverflow),
  rr-cinta.js (vídeos) ni rr-nav.js (mega-menú). Aquí sólo se arbitra qué panel
  está visible, que es una responsabilidad entera.

  Patrón WAI-ARIA de tabs con ACTIVACIÓN AUTOMÁTICA (la flecha selecciona, no hace
  falta Enter), igual que el índice de reseñas documentado en DESIGN_SYSTEM.md:
   - roving tabindex (0 en la activa, -1 en el resto),
   - las CUATRO flechas: la fila envuelve en móvil, así que no hay un único eje y
     por eso el marcado no declara aria-orientation,
   - Home / End,
   - el foco viaja con la selección.

  Contrato de seguridad, el mismo de rr-reveal: el contenido es VISIBLE por
  defecto. Si este archivo no llega a ejecutarse, no se añade .is-js, la fila de
  teclas se queda en display:none (CSS) y los cinco paneles se leen apilados. No
  hay ningún estado en el que quede un control muerto o una métrica escondida.
*/
(function () {
  'use strict';

  function montar(raiz) {
    if (raiz.dataset.rrMetricasListo === '1') return;

    var tabs = Array.prototype.slice.call(raiz.querySelectorAll('[role="tab"]'));
    var paneles = Array.prototype.slice.call(raiz.querySelectorAll('[role="tabpanel"]'));
    // Con una sola métrica no hay nada que elegir: mejor dejarla suelta y visible.
    if (tabs.length < 2 || tabs.length !== paneles.length) return;

    raiz.dataset.rrMetricasListo = '1';
    raiz.classList.add('is-js');

    // El panel no contiene nada enfocable, así que se hace enfocable él. Se pone
    // desde JS y no en el Liquid para no dejar cinco paradas de tabulador muertas
    // en el caso sin JS, donde los paneles están todos apilados.
    paneles.forEach(function (panel) {
      panel.setAttribute('tabindex', '0');
    });

    var activa = 0;

    function activar(indice, moverFoco) {
      activa = (indice + tabs.length) % tabs.length;

      tabs.forEach(function (tab, i) {
        var sel = i === activa;
        tab.setAttribute('aria-selected', sel ? 'true' : 'false');
        tab.setAttribute('tabindex', sel ? '0' : '-1');
      });

      paneles.forEach(function (panel, i) {
        var sel = i === activa;
        panel.hidden = !sel;
        panel.classList.remove('is-entrando');
        if (sel && moverFoco) {
          // Reinicia la animación de entrada: sin leer offsetWidth el navegador
          // agrupa quitar y poner la clase en el mismo fotograma y no reinicia.
          void panel.offsetWidth;
          panel.classList.add('is-entrando');
        }
      });

      if (moverFoco) tabs[activa].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        if (i !== activa) activar(i, false);
      });

      tab.addEventListener('keydown', function (ev) {
        var destino = null;
        switch (ev.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            destino = activa + 1;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            destino = activa - 1;
            break;
          case 'Home':
            destino = 0;
            break;
          case 'End':
            destino = tabs.length - 1;
            break;
          default:
            return;
        }
        ev.preventDefault();
        activar(destino, true);
      });
    });

    // Estado inicial: la primera. El marcado ya la trae marcada, pero esto es lo
    // que oculta de verdad los otros cuatro paneles (hasta aquí eran visibles).
    activar(0, false);
  }

  function init(ambito) {
    var raices = (ambito || document).querySelectorAll('[data-rr-metricas]');
    Array.prototype.forEach.call(raices, montar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // El editor de temas vuelve a pintar la sección al tocar un bloque: sin esto
  // Pablo vería los cinco paneles apilados mientras edita.
  document.addEventListener('shopify:section:load', function (ev) {
    init(ev.target);
  });
})();
